// Class hook for AppModal and for antd's static dialogs (Modal.confirm / Modal.error).
export const appModalClass = (kind) => `app-modal app-modal--${kind}`;
